import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isContactsFirstName(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_FIRST_NAME && typeof label === 'string' && typeof value === 'string';
}
function _formatContactsFirstName(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatContactsFirstName(submission) {
  if (isContactsFirstName(submission)) {
    return _formatContactsFirstName(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-first-name-preview.js.map